import Marquee from "react-fast-marquee";
import { CAR_BRANDS } from "@/data/site";

export default function BrandMarquee() {
  return (
    <section className="relative border-y border-white/10 bg-[#080808] py-8" data-testid="brand-marquee">
      <p className="mb-6 text-center font-body text-[11px] font-bold uppercase tracking-[0.3em] text-neutral-500">
        Markenübergreifend · Wir arbeiten an nahezu jedem Fahrzeug
      </p>
      <Marquee gradient gradientColor="#080808" gradientWidth={120} speed={40} pauseOnHover>
        {CAR_BRANDS.map((b) => (
          <span
            key={b}
            className="mx-8 font-heading text-2xl font-bold uppercase tracking-wide text-neutral-600 transition-colors hover:text-volt sm:text-3xl"
          >
            {b}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
